import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { withRouter } from "react-router-dom";
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import BusinessApi from 'apis/Business';
import SurveyTemplateApi from 'apis/SurveyTemplate';
import { setQuestionAttributes, getBusinessId, removeSuggestedTemplate, getSuggestedTemplate, setSelectedTemplates } from 'constants/localStorageManager';
import "assets/scss/surveyTemplate.css";

import SurveyCategoryList from './SurveyCategoryList';
import SurveyTemplateDetailModal from '../customSurvey/SurveyTemplateDetailModal';
import SelectedTemplatesBar from './SelectedTemplatesBar';
import SurveyCategoryFilter from './SurveyCategoryFilter';
import SurveyTemplateSearch from './SurveyTemplateSearch';
import Toaster from '../Toaster';
import Loading from '../../utils/Loading';

export const BLANK_SURVEY_TEMPLATE = {
  id: null,
  name: 'Blank Survey'
};

class SurveyTemplates extends React.Component {
  constructor() {
    super();

    this.state = {
      modal: false,
      businessCategories: [],
      surveyCategories: [],
      surveyCategoriesNames: [],
      filterCategory: { name: 'All' },
      questionAnswers: [],
      selectedTemplates: [],
      selectedTemplate: null,
      questionAttributes: [],
      searchText: '',
      isLoading: false
    }

  }

  componentDidMount() {
    this.checkSuggestedTemplate();
    this.fetchAllSurveyCategories();
    this.fetchSurveyCategoriesName();
  }

  checkSuggestedTemplate = () => {
    const selectedTemplate = getSuggestedTemplate();
    if (selectedTemplate) {
      this.setState({ isLoading: true });
      this.selectSurvey(selectedTemplate).then(() => {
        this.createUserSurvey();
        removeSuggestedTemplate();
        this.setState({ isLoading: false });
      });
    }
  }

  fetchSurveyCategoriesName = () => {
    const dropDown = true;
    SurveyTemplateApi.getAllCategories(dropDown).then(({ data }) => {
      this.setState({ surveyCategoriesNames: data });
    }).catch(console.log)
  }

  fetchAllSurveyCategories = () => {

    SurveyTemplateApi.getAllCategories().then(({ data }) => {
      this.setState({
        surveyCategories: data.filter(dt => dt.survey_templates.length > 0)
      });

      return this.fetchBusinessDetail()
    }).then(businessCategories => {

      this.setState({
        businessCategories,
        surveyCategories: this.withSuggestedCategories(this.state.surveyCategories, businessCategories)
      });

    }).catch(e => {
      console.log(e)
      Toaster.getErrorToaster('exclamation-triangle', 'Error while fetching data')
    });
  }

  fetchBusinessDetail = () => {
    let { id } = this.props.match.params;
    id = id || getBusinessId();

    return new Promise((resolve, reject) => {
      BusinessApi.getDetails(id).then(({ data }) => {
        const { categories } = data;

        return resolve(categories.map(cat => cat.name));
      }).catch(e => {
        reject(e);
      })
    })
  }

  getQuestionAttributes = (surveyTemplate) => {
    return new Promise((resolve, reject) => {
      SurveyTemplateApi.getDetails(surveyTemplate.id)
        .then(({ data }) => {
          const questionAttributes = data && data.survey_template_questions && data.survey_template_questions.length ? this.buildQuestionAttributes(data) : [];

          return resolve(questionAttributes);
        })
        .catch(e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon='exclamation-triangle' />Error while fetching data{' '}
            </div>
          )),
          reject(e)));
    });
  }

  isTemplateSelected = (identifier = BLANK_SURVEY_TEMPLATE) => {
    if (identifier) {
      const result = this.state.selectedTemplates.find(({ id }) => id == identifier.id);
      return result;
    }
    return false;
  }

  selectSurvey = async (surveyTemplate) => {
    const { selectedTemplates, questionAnswers } = this.state;
    let _questionAnswers, _selectedTemplates;

    if (!surveyTemplate) {
      const _selectedTemplates = this.isTemplateSelected() ?
        selectedTemplates.filter(selectedTemplate => selectedTemplate !== BLANK_SURVEY_TEMPLATE)
        : [...selectedTemplates, BLANK_SURVEY_TEMPLATE];

      this.setState({ selectedTemplates: _selectedTemplates, modal: false });

      return;
    }

    if (this.isTemplateSelected(surveyTemplate)) {
      // Unselect the questions and template
      _questionAnswers = questionAnswers.filter(questionAnswer => questionAnswer.surveyTemplateId !== surveyTemplate.id);
      _selectedTemplates = selectedTemplates.filter(selectedTemplate => selectedTemplate.id !== surveyTemplate.id);

      this.setState({ selectedTemplates: _selectedTemplates, questionAnswers: _questionAnswers, modal: false });

      return;
    }

    return this.getQuestionAttributes(surveyTemplate)
      .then(questionAttributes => {
        _questionAnswers = questionAnswers.concat(questionAttributes);
        _selectedTemplates = [...selectedTemplates, surveyTemplate];

        this.setState({ selectedTemplates: _selectedTemplates, questionAnswers: _questionAnswers, modal: false });
        const name = _selectedTemplates[0].name
        this.props.collectSurveyName(name)
      })
      .catch(e => console.log(e));
  }

  createUserSurvey = (surveyTemplate) => {
    const { questionAnswers, selectedTemplates } = this.state;
    const { hideSurveyList } = this.props;
    const questionAttributes = questionAnswers.map(questionAnswer => {
      const { surveyTemplateId, ...res } = questionAnswer;

      return res;
    });

    setQuestionAttributes(questionAttributes);
    setSelectedTemplates(selectedTemplates)
    hideSurveyList();
  }

  useTemplate = () => {
    const { selectedTemplate } = this.state;
    this.selectSurvey(selectedTemplate);
  }

  viewSurveyDetail = (surveyTemplate) => {
    surveyTemplate ?
      this.getQuestionAttributes(surveyTemplate)
        .then(questionAttributes => {
          this.setState({ selectedTemplate: surveyTemplate, modal: true, questionAttributes })
        })
        .catch(e => console.log(e))
      :
      this.setState({ selectedTemplate: surveyTemplate, modal: true, questionAttributes: [] })
  }

  buildQuestionAttributes = (surveyTemplateWithQuestions) => {
    const surveyTemplateId = surveyTemplateWithQuestions.id

    const questionAttributes = surveyTemplateWithQuestions.survey_template_questions.map((surveyTemplateQuestion) => {
      return {
        surveyTemplateId,
        question: surveyTemplateQuestion.question,
        input_type_id: surveyTemplateQuestion.input_type.id,
        survey_template_question_id: surveyTemplateQuestion.id,
        answers_attributes: surveyTemplateQuestion.answers && surveyTemplateQuestion.answers.length ?
          surveyTemplateQuestion.answers.map(singleAnswer => ({ survey_template_question_answer_id: singleAnswer.id, answer: singleAnswer.answer })) : []
      }
    });

    return questionAttributes;
  }

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  handleFilter = (category) => {
    const filterCategory = category;

    this.setState({ filterCategory });
  }

  handleSearch = (e) => {
    const { value } = e.target;

    this.setState({ searchText: value });
  }

  withSuggestedCategories = (surveyCategories, businessCategories) => {
    return [{
      id: surveyCategories.length,
      name: "Suggested Surveys",
      is_suggested: true,
      survey_templates: this.compileSuggestedCategories(surveyCategories, businessCategories)
    }].concat(surveyCategories);
  }

  compileSuggestedCategories = (surveyCategories, businessCategories) => {
    let similarCategories = [];

    let surveyTemplates = surveyCategories.map(sv => sv.survey_templates).reduce((acc, val) => acc.concat(val), []);

    surveyTemplates.forEach(temp => {
      const categories = temp.categories.map(cat => cat.name);

      for (let category of categories) {
        if (businessCategories.includes(category)) {
          similarCategories.push(temp);
          break;
        }
      }
    });

    return similarCategories;
  }

  render() {
    const {
      modal,
      selectedTemplate,
      questionAttributes,
      selectedTemplates,
      surveyCategories,
      surveyCategoriesNames,
      filterCategory,
      searchText,
      isLoading
    } = this.state;
    const btnDisabled = selectedTemplates.length < 1;

    if (isLoading) {
      return <Loading title={"Creating Survey"} />
    }

    return (
      <React.Fragment>
        <SurveyTemplateDetailModal
          modal={modal}
          toggle={this.toggleModal}
          useTemplate={this.useTemplate}
          isTemplateSelected={this.isTemplateSelected}
          selectedTemplate={selectedTemplate}
          questionAttributes={questionAttributes}
        />
        <div className='row mt-4 p-0'>
          <div className="col-md-9 col-xs-12 col-sm-12 p-0 mb-4 responsive-flex">
            <div className="col-sm-12 col-md-6 survey-template-dropdown">
              <b>View Category:</b> {" "}
              <SurveyCategoryFilter
                title={filterCategory.name}
                dropDownItems={surveyCategoriesNames}
                handleFilter={this.handleFilter}
              />
            </div>
            <div className="col-md-6 col-sm-12 survey-search">
              <SurveyTemplateSearch
                handleSearch={this.handleSearch}
                searchText={searchText}
              />
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-3 survey-template-actions'>
            <div className='btn-group w-100'>
              <button
                className='btn-add btn btn-secondary w-100 mr-0'
                onClick={this.createUserSurvey}
                disabled={btnDisabled}
              >
                Next: Create Survey
              </button>
            </div>
          </div>
        </div>
        <div className="row mb-4 selected-template-bar affix">
          <SelectedTemplatesBar
            selectedTemplates={selectedTemplates}
            selectSurvey={this.selectSurvey}
          />
        </div>
        <SurveyCategoryList
          filterCategory={filterCategory}
          surveyTemplatesList={surveyCategories}
          selectSurvey={this.selectSurvey}
          isTemplateSelected={this.isTemplateSelected}
          viewSurveyDetail={this.viewSurveyDetail}
          searchText={searchText}
        />
      </React.Fragment>
    );
  }
}

SurveyTemplates.propTypes = {
  hideSurveyList: PropTypes.func
};

export default withRouter(SurveyTemplates);



// WEBPACK FOOTER //
// ./src/components/survey-templates/index.js